"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var SearchQueryAction;
(function (SearchQueryAction) {
    SearchQueryAction.DEBOUNCE_SEARCH = 'DEBOUNCE_SEARCH';
    SearchQueryAction.SEARCH_QUERY = 'SEARCH_QUERY';
    SearchQueryAction.UPDATE_CRITERIA = 'UPDATE_CRITERIA';
    SearchQueryAction.debounceSearch = typesafe_actions_1.createAction(SearchQueryAction.DEBOUNCE_SEARCH, function (resolve) { return function (viewport) { return resolve({ viewport: viewport }); }; });
    SearchQueryAction.search = typesafe_actions_1.createAction(SearchQueryAction.SEARCH_QUERY, function (resolve) { return function (viewport) { return resolve({ viewport: viewport }); }; });
    SearchQueryAction.updateCriteria = typesafe_actions_1.createAction(SearchQueryAction.UPDATE_CRITERIA, function (resolve) { return function () { return resolve(); }; });
})(SearchQueryAction || (SearchQueryAction = {}));
exports.default = SearchQueryAction;
